import type { IChartApi, ISeriesApi, UTCTimestamp } from "lightweight-charts";
import { HistogramSeries } from "lightweight-charts";

export type VolumePoint = {
  time: UTCTimestamp;
  value: number;
  color?: string;
};

const safeNumber = (n: unknown): number => {
  const x = typeof n === "number" ? n : Number(n);
  return Number.isFinite(x) ? x : 0;
};

const safeColor = (c: unknown): string | undefined => {
  if (typeof c !== "string") return undefined;
  const s = c.trim();
  return s.length ? s : undefined;
};

export function addVolumeSeries(chart: IChartApi) {
  const c: any = chart as any;
  const safeOptions = {
    priceFormat: { type: "volume" },
    priceScaleId: "",
    lastValueVisible: false,
    priceLineVisible: false,
  };

  let volumeSeries: any = null;
  if (typeof c.addHistogramSeries === "function") {
    volumeSeries = c.addHistogramSeries(safeOptions);
  } else if (typeof c.addSeries === "function") {
    try {
      volumeSeries = HistogramSeries ? c.addSeries(HistogramSeries, safeOptions) : c.addSeries("Histogram", safeOptions);
    } catch {
      volumeSeries = null;
    }
  }

  if (!volumeSeries) throw new Error("chart.addHistogramSeries is not available");

  volumeSeries.priceScale().applyOptions({
    scaleMargins: {
      top: 0.75,
      bottom: 0.0,
    },
  });

  return {
    series: volumeSeries as ISeriesApi<"Histogram">,

    setData(raw: Array<{ time: any; value: any; color?: any }>) {
      const data: VolumePoint[] = raw
        .filter((p) => p?.time != null)
        .map((p) => ({
          time: p.time as UTCTimestamp,
          value: safeNumber(p.value),
          color: safeColor(p.color),
        }));
      volumeSeries.setData(data);
    },

    update(raw: { time: any; value: any; color?: any }) {
      if (!raw || raw.time == null) return;
      volumeSeries.update({
        time: raw.time as UTCTimestamp,
        value: safeNumber(raw.value),
        color: safeColor(raw.color),
      });
    },
  };
}
